import { render, staticRenderFns } from "./social-proof-strip.vue?vue&type=template&id=511c3254&scoped=true"
import script from "./social-proof-strip.vue?vue&type=script&lang=js"
export * from "./social-proof-strip.vue?vue&type=script&lang=js"
import style0 from "./social-proof-strip.vue?vue&type=style&index=0&id=511c3254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c3254",
  null
  
)

export default component.exports